body.safari .docs-copy-to-cb .ld-button {
  outline: none;
}
